module.exports = "/_next/static/images/850d15ec9af278ad17c8d972114bdc26-Nubank_HickDuarte_55193_xs.jpg.webp";